(function($) {
  $(document).ready(function(){

  //alert('Carousel Loaded OK');
  //console.log('Carousel Loaded');
  
  var $status = $('.pagingInfo');
  var $carouselElement = $('.carousel');

  // Get current and total slides (ie. 1/15)
  $carouselElement.on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
    //currentSlide maybe undefined on init, so lets set it to 0 (currentSlide is 0 based)
    if(!slick.$dots){
      return;
    }
    
    var i = (currentSlide ? currentSlide : 0) + 1;
    $status.text(i + '/' + (slick.$dots[0].children.length));
  });

  // customizing dots
  $carouselElement.on('init', function(event, slick){
    var $items = slick.$dots.find('li');
    $items.addClass('transparent-circle');
    $items.find('button').remove();
  });

  // Setup
  $carouselElement.slick({
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false,
    infinite: true,
    autoplaySpeed: 2000,
    //cssEase:'ease',
    cssEase: 'linear',
    dots:true,
    prevArrow: $('.prev'),
    nextArrow: $('.next'),
    responsive: [{
      breakpoint: 1024,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: false,
        adaptiveHeight: true,
      }

    }, {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: false,
      }
    }, {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: false
      }
    }]
  });

  /**
   * Check breakpoint console.log
   */
  /*
  $carouselElement.on('breakpoint', function(event, slick, breakpoint) {
    console.log('breakpoint ' + breakpoint);
  });
  */

});
})(jQuery);

